import { useState, useEffect } from "react";
import { useSettingsSection } from "@/lib/useSettingsSection";
import { PageTitle, Card, Field, inputCls, SaveButton } from "@/components/admin/ui";
import { ImageField } from "@/components/admin/MediaPicker";

export default function AdminSEO() {
  const { settings, saving, save } = useSettingsSection();
  const [s, setS] = useState({});
  useEffect(() => { if (settings) setS(settings.seo || {}); }, [settings]);
  if (!settings) return <div className="text-slate-400">Loading…</div>;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });

  return (
    <div data-testid="admin-seo">
      <PageTitle title="SEO Settings" subtitle="Site-wide SEO and analytics configuration" />
      <div className="space-y-6">
        <Card title="Homepage & Site SEO">
          <Field label="Site SEO Title"><input className={inputCls} value={s.home_title || ""} onChange={set("home_title")} data-testid="seo-title-input" /></Field>
          <Field label="Site Meta Description"><textarea rows={3} className={inputCls} value={s.home_description || ""} onChange={set("home_description")} data-testid="seo-desc-input" /></Field>
          <Field label="Default Keywords"><input className={inputCls} value={s.keywords || ""} onChange={set("keywords")} /></Field>
          <Field label="Canonical Base URL" hint="e.g. https://www.yourdomain.com (no trailing slash)"><input className={inputCls} value={s.canonical_base || ""} onChange={set("canonical_base")} /></Field>
          <Field label="Default OG Image"><ImageField value={s.default_og_image} onChange={(v) => setS({ ...s, default_og_image: v })} /></Field>
        </Card>
        <Card title="Analytics & Verification">
          <Field label="Google Analytics ID" hint="e.g. G-XXXXXXX"><input className={inputCls} value={s.ga_id || ""} onChange={set("ga_id")} /></Field>
          <Field label="Google Tag Manager ID"><input className={inputCls} value={s.gtm_id || ""} onChange={set("gtm_id")} /></Field>
          <Field label="Google Search Console Verification"><input className={inputCls} value={s.gsc_verification || ""} onChange={set("gsc_verification")} /></Field>
        </Card>
        <SaveButton onClick={() => save({ seo: s })} saving={saving} testid="save-seo" />
      </div>
    </div>
  );
}
